import { ja } from 'date-fns/locale';
import { useField } from 'formik';
import React, { useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import { DateFormatForDatePickerJP } from '../../constants/date-picker-constant';
import { useStore } from '../../contexts/store-provider';
import FormikFormErrorHandler from './FormikFormErrorHandler';

registerLocale('jp', ja);
interface IProps {
  children: React.ReactNode;
  className: string;
  name: string;
  'data-testid'?: string;
  intl: any;
  onChange: () => void;
  value: any;
  disabled: boolean;
  readOnly: boolean;
  label?: string;
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;
  isClearable?: boolean;
}

const FormikFormDatePicker = (props: IProps) => {
  const [field, meta, helpers] = useField(props);
  const { preferencesStore } = useStore();
  const [focus, setFocus] = useState(false);
  const language = preferencesStore.getLanguage;
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);

  const handleCalendarClose = () => {
    if (calendarIsOpen) setCalendarIsOpen(false);
  };

  const onClickCalendarIcon = () => {
    setCalendarIsOpen(!calendarIsOpen);
  };

  const blurHandler = () => {
    if (!props.value) setFocus(false);
  };

  useEffect(() => {
    if (props.value) setFocus(true);
  }, [props.value]);

  return (
    <>
      <DatePicker
        {...props}
        {...field}
        dateFormat={props.dateFormat || DateFormatForDatePickerJP}
        locale={language}
        // id="calendar-icon"
        selected={field.value}
        onChange={(date: Date) => {
          helpers.setValue(date || '');
        }}
        open={calendarIsOpen}
        onClickOutside={handleCalendarClose}
        onInputClick={() => {
          setCalendarIsOpen(true);
        }}
        onFocus={() => setFocus(true)}
        onBlur={blurHandler}
        onSelect={(date: Date) => {
          helpers.setValue(date || '');
          handleCalendarClose();
        }}
        onKeyDown={(e) => e.preventDefault()}
        onChangeRaw={(e) => e.preventDefault()}
        isClearable={props.isClearable}
      />
      {props.label && (
        <label className={`${focus ? 'label-focus' : ''}`}>
          <span>
            <FormattedMessage id={props.label} />
          </span>
        </label>
      )}
      {/* <span className="material-symbols-outlined calendar-icon" onClick={props.disabled ? () => false : onClickCalendarIcon}>calendar_month</span> */}
      <FormikFormErrorHandler
        intl={props.intl}
        meta={meta}
      />
    </>
  );
};

export default injectIntl(FormikFormDatePicker);
